import Templates from './Templates';

export default Templates;